<template>
    <div class="user-login-form">

        <b-form @submit.stop.prevent="onSubmit">

            <b-form-group horizontal
                          label-cols="12"
                          label="Email"
                          :invalid-feedback="invalidFeedback('email')">
                <b-form-input ref="email"
                              class="test-email-input"
                              type="text"
                              autocomplete="email"
                              v-model="$v.email.$model"
                              :state="state('email')"/>
            </b-form-group>
            <b-form-group horizontal
                          label-cols="12"
                          label="Password"
                          :invalid-feedback="invalidFeedback('password')">
                <b-form-input type="password"
                              class="test-password-input"
                              autocomplete="password"
                              v-model="$v.password.$model"
                              :state="state('password')"/>
            </b-form-group>

            <b-button class="float-right test-submit-button"
                      type="submit"
                      variant="primary"
                      :disabled="$v.email.$invalid || $v.password.$invalid">
                Login
            </b-button>

        </b-form>

        <div style="clear:both"/>

        <b-alert show variant="danger" class="mt-3"
                 v-if="loginError">
            {{ loginError }}
        </b-alert>

    </div>

</template>

<script>

import Vue from 'vue'

import { validationMixin } from 'vuelidate'
import { email, minLength, required } from 'vuelidate/lib/validators'

export default Vue.extend({
    name: 'UserLoginForm',
    mixins: [validationMixin],
    data () {
        return {
            email: '',
            password: '',
            loginError: false
        }
    },
    validations: {
        email: { required, email },
        password: { required, minLength: minLength(4) }
    },
    methods: {
        state (fieldName) {
            const f = this.$v[fieldName]
            if (f) {
                return f.$dirty ? !f.$error : null
            } else {
                return null
            }
        },
        invalidFeedback (/*fieldName*/) {
            return ''
        },
        blur () {
            this.$v.$touch()
        },
        async onSubmit (evt) {
            this.blur()
            if (!this.$v.email.$error && !this.$v.password.$error) {
                try {
                    // check for requested path - e.g. URL is ?requestedPath/equipment%2Flist
                    const requestedPath = this.$route.query['requestedPath']
                    const data = await this.$user.loginUser(this, this.email, this.password)
                    //  check 2FA
                    if (data['disabled']) {
                        alert('Your Account has been disabled.\nContact a system administrator for more information.')
                    } else if (data['twofa_enabled']) {
                        // switch to two-factor authentication
                        this.$router.push(requestedPath ? `/2fa?requestedPath=${requestedPath}` : '/2fa')
                    } else if (requestedPath) {
                        this.$router.push(decodeURIComponent(requestedPath))
                    } else {
                        if (this.$router.currentRoute.path !== '/') {
                            this.$router.replace('/')
                        }
                    }
                } catch (e) {
                    this.loginError = 'Incorrect login!'
                    if (e && e.body) {
                        if (e.body.message) {
                            this.loginError = e.body.message
                        } else if (e.body.name) {
                            this.loginError = e.body.name
                        }
                    }
                }
            }
        }
    },
    mounted () {
        Vue.nextTick(() => this.$refs.email.$el.focus())
    },
})
</script>
